import { useEffect } from 'react';

import { useCreateSetupIntentMutation } from './graphql/SetupIntent.generated';

export function useSetupIntent() {
  const [response, refetchSetupIntent] = useCreateSetupIntentMutation();

  useEffect(() => {
    void refetchSetupIntent({});
  }, [refetchSetupIntent]);

  const setupIntentSecret = response?.data?.createPaymentIntent;
  const isFetchingSetupIntent = response.fetching;

  return {
    setupIntentSecret,
    isFetchingSetupIntent,
    refetchSetupIntent,
  };
}
